import { render, staticRenderFns } from "./Testmonialadmin.vue?vue&type=template&id=4498146e"
import script from "./Testmonialadmin.vue?vue&type=script&lang=js"
export * from "./Testmonialadmin.vue?vue&type=script&lang=js"
import style0 from "./Testmonialadmin.vue?vue&type=style&index=0&id=4498146e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports